import { render, staticRenderFns } from "./agentDetail.vue?vue&type=template&id=144b4a0a&"
import script from "./agentDetail.vue?vue&type=script&lang=js&"
export * from "./agentDetail.vue?vue&type=script&lang=js&"
import style0 from "./agentDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports